import router from '../../router/index'

const management = {
  state: {
    // view视图tab
    tabNumber: 0,
    // 授权店铺数量
    storeNum: 0,
    // 授权仓库数量
    wareHouseNum: 0,
    // 仓库容量
    wareHouseNumSum: 0,
    // 已开通的服务
    server: [],
    // 是否配置了物流模块
    logisticsConfig: false
  },
  mutations: {
    SET_TABNUMBER: (state, tabNumber) => {
      state.tabNumber = tabNumber
    },
    SET_AUTHORIZEDSTORENUM: (state, num) => {
      state.storeNum = num
    },
    SET_AUTHORIZEDWAREHOUSENUM: (state, num) => {
      state.wareHouseNum = num
    },
    SET_AUTHORIZEDWAREHOUSENUMSUM: (state, num) => {
      state.wareHouseNumSum = num
    },
    SET_SERVER: (state, server) => {
      state.server = server
    },
    SET_LOGISTICSCONFIG: (state, bool) => {
      state.logisticsConfig = bool
    }
  },
  actions: {
    // 管理后台
    // 前端登录
    // LoginIn({ commit }, userInfo) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', userInfo.token)
    //     setToken(userInfo.token)
    //     resolve()
    //   })
    // },
    // 前端登出
    LoginOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TABNUMBER', '')
        commit('SET_AUTHORIZEDSTORENUM', '')
        commit('SET_LOGISTICSCONFIG', '')
        commit('SET_SERVER', '')
        localStorage.removeItem('manageLoginInfo')
        router.push('/management/login')
        resolve()
      })
    }
  }
}

export default management



// WEBPACK FOOTER //
// ./src/store/modules/management.js